import { ApplicationRef, Injectable } from '@angular/core';
import { url } from 'inspector';
import { Socket } from 'ngx-socket-io';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class SocketService {

  constructor(
    private socket : Socket,
    private appRef: ApplicationRef
  ) { }

  connect() {   
    const id = localStorage.getItem('id');
    if (!id) {
      console.error('User ID is not available in localStorage!');
      return;
    }
    const url = `${environment.SOCKET_BASE_URL}?id=${id}`;

    // Dynamically initialize the socket
    this.socket = new Socket({ url, options: {} }, this.appRef);

    this.socket.connect();

    // Handle socket events
    this.socket.fromEvent('connect').subscribe(() => {
      console.log('Socket connected successfully!');
    });

    this.socket.fromEvent('connect_error').subscribe((err: any) => {
      console.error('Socket connection error:', err);
    });

    this.socket.fromEvent('disconnect').subscribe(() => {
      console.log('Socket disconnected');
    });
  }




  /**
   * Listens for an event with the specified name on the socket.
   *
   * @param eventName The name of the event to listen for.
   * @returns An Observable that emits the event data when the event occurs.
   */
  listen(eventName: string): Observable<any> {
    console.log('socket values',this.socket.fromEvent(eventName))
      return this.socket.fromEvent(eventName);   
  }

  /**
   * Emits an event with the specified name and data to the socket.
   *
   * @param event The name of the event to emit.
   * @param data The data to send with the event.
   */
  emit(event: string, data: any) {
    this.socket.emit(event, data);
  }

  /**
   * Listens for an event with the specified name on the socket.
   *
   * @param event The name of the event to listen for.
   * @returns An Observable that emits the event data when the event occurs.
   *
   * Note: This observable will automatically unsubscribe from the event when
   * the observable is complete or unsubscribed from.
   */
  on(event: string): Observable<any> {
    return new Observable((observer) => {
      this.socket.on(event, (data: any) => {
        console.log('data', data);        
        observer.next(data);
      });
      return () => {
        this.socket.off(event);
      }
    })
  }
}


